export default __webpack_public_path__ + "static/media/languages.02fba550.png";